const features = {
    id: {
        name: 'ID',
        description: 'Use ID rights matrix',
        active: true,
    },
    debug: {
        viadialog: {
            name: 'Viadialog',
            description: 'Fake the user is or is not an agent',
            active: false,
            value: false,
        },
    },
};
export default features;
